import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'studio-video-popup',
  templateUrl: './video-popup.component.html',
  styleUrls: ['./video-popup.component.scss'],
})
export class VideoPopupComponent {
  @Input() message: string;
  @Input() actionLabel = 'Dismiss';
  @Output() actionClicked = new EventEmitter<void>();

  protected buttonClicked() {
    this.actionClicked.emit();
  }
}
